export const recepcionista = {
  nome: 'Recepcionista',
  id_perfil: 5,
  dashboard: [
    {
      link: '/vinculo-acompanhamento',
      titulo: 'Vínculo e Acompanhamento',
      icone: false,
      imagem: '',
      svg: 'VinculoAcompanhamento',
      key: 'vinculo_acompanhamento',
      featured: true,
    },
    {
      link: '/indicadores-aps',
      titulo: 'Indicadores APS',
      icone: false,
      imagem: '',
      svg: 'IndicadoresAps',
      key: 'indicadores_aps',
      featured: true,
    },
    {
      link: '/gestao-cadastros',
      titulo: 'Gestão cadastros',
      icone: false,
      imagem: '',
      svg: 'GestaoCadastros',
      key: 'gestao_cadastros',
    },
    {
      link: '/cidadaos-cns-invalidos',
      titulo: 'Cidadãos CNS inválido',
      icone: 'icofont-close-circled',
      key: 'cns_invalido',
    },
    {
      link: '/cidadaos-desatualizados',
      titulo: 'Cidadãos desatualizados',
      icone: 'icofont-loop',
      key: 'cidadaos_desatualizados',
    },
    {
      link: '/aedes-aegypti/acs',
      titulo: 'Aedes aegypti',
      icone: false,
      imagem: '',
      svg: 'AedesAegypti',
      key: 'aedes_aegypti',
    },
    {
      link: '/pos-covid-19/acs',
      titulo: 'Pós Covid-19',
      icone: false,
      imagem: '',
      svg: 'PosCovid19',
      key: 'pos_covid_19',
    },
  ],
  administracao: [],
  gestao_cadastros: [
    {
      link: '/acs-por-cidadao',
      titulo: 'Cidadão',
      icone: 'icofont-users-alt-4',
      key: 'cidadao',
    },
    {
      link: '/cidadaos-desvinculados',
      titulo: 'Cidadãos sem equipe',
      icone: 'icofont-people',
      key: 'cidadaos_sem_equipe',
    },
    {
      link: '/cidadaos-duplicados/equipe',
      titulo: 'Cidadãos duplicados',
      icone: 'icofont-copy-invert',
      key: 'cidadaos_duplicados',
    },
    {
      link: '/calculadora-de-pessoas/equipe',
      titulo: 'Calculadora de pessoas',
      icone: 'icofont-ui-calculator',
      key: 'calculadora_de_pessoas',
    },
    {
      link: '/obitos/profissional',
      titulo: 'Óbitos',
      icone: 'icofont-list',
      key: 'obitos',
    },
    {
      link: '/mudanca_territorio/profissional',
      titulo: 'Mudança de Território',
      icone: 'icofont-list',
      key: 'mudanca_territorio',
    },
  ],
  visitas_domiciliares: [],
  imunizacao: [],
  vacina_idade_certa: [],
  divergencia_vacinas: [],
  indicadores_aps: [
    {
      link: '/busca-ativa/equipe/acs',
      titulo: 'Busca Ativa',
      icone: 'icofont-search-user',
      key: 'busca_ativa',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
    {
      link: '/indicador-citologico/profissional',
      titulo: 'Exames Citopatológico',
      icone: 'icofont-stretcher',
      key: 'citopatologico',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
    {
      link: '/indicador-imunizacao/profissional',
      titulo: 'Desenvolvimento infantil',
      icone: 'icofont-baby',
      key: 'vacinas_polio_penta',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
    {
      link: '/pre-natal',
      titulo: 'Gestantes e Puérperas',
      icone: false,
      imagem: require('@/assets/images/pregnant.png'),
      key: 'pre_natal',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
    {
      link: '/doencas-cronicas',
      titulo: 'Doenças crônicas',
      icone: 'icofont-drug',
      key: 'doencas_cronicas',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
    {
      link: '/saude-da-mulher',
      titulo: 'Saúde da mulher',
      icone: 'icofont-female',
      key: 'saude_da_mulher',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
    {
      link: '/pessoa-idosa',
      titulo: 'Pessoa idosa',
      icone: 'icofont-drug',
      key: 'pessoa_idosa',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
    {
      link: '/primeira-consulta-programada',
      titulo: '1ª Consulta programada',
      icone: false,
      imagem: '',
      svg: 'PrimeiraConsultaProgramada',
      key: 'primeira_consulta_programada',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/tratamentos-concluidos',
      titulo: 'Tratamentos concluídos',
      icone: false,
      imagem: '',
      svg: 'TratamentosConcluidos',
      key: 'tratamentos_concluidos',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/exodontias',
      titulo: 'Exodontias',
      icone: false,
      imagem: '',
      svg: 'Exodontias',
      key: 'exodontias',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/escovacao-supervisionada',
      titulo: 'Escovação supervisionada',
      icone: false,
      imagem: '',
      svg: 'EscovacaoSupervisionada',
      key: 'escovacao_supervisionada',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/proporcao-procedimentos-preventivos',
      titulo: 'Procedimentos preventivos',
      icone: false,
      imagem: '',
      svg: 'Prevencao',
      key: 'proporcao_procedimentos_preventivos',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/tratamentos-restauradores-art',
      titulo: 'Tratamento restaurador',
      icone: false,
      imagem: '',
      svg: 'TratamentosRestauradoresArt',
      key: 'tratamentos_restauradores_art',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/cuidado-compartilhado',
      titulo: 'Cuidado compartilhado',
      icone: 'icofont-duotone icofont-field-group',
      key: 'cuidado_compartilhado',
      ribbon: {
        enabled: true,
        text: 'eMulti',
      },
    },
    {
      link: '/acoes-interprofissionais',
      titulo: 'Ações interprofissionais',
      icone: 'icofont-duotone icofont-field-group',
      key: 'acoes_interprofissionais',
      ribbon: {
        enabled: true,
        text: 'eMulti',
      },
    },
    {
      link: '/comunicacao-emulti-e-equipes',
      titulo: 'Comunicação',
      icone: 'icofont-ui-chat',
      key: 'comunicacao_emulti_equipes',
      ribbon: {
        enabled: true,
        text: 'eMulti',
      },
    },
    {
      link: '/resolutividade-cuidado-emulti',
      titulo: 'Resolutividade',
      icone: 'icofont-duotone icofont-field-group',
      key: 'resolutividade_cuidado_emulti',
      ribbon: {
        enabled: true,
        text: 'eMulti',
      },
    },
    // {
    //   link: '/resultado-indicadores',
    //   titulo: 'Resultado Indicadores',
    //   icone: false,
    //   imagem: '',
    //   svg: 'ResultadoIndicadores',
    //   key: 'resultado_indicadores',
    // },
    {
      link: '/desempenho-por-equipe',
      titulo: 'Desempenho por Equipe',
      icone: false,
      imagem: '',
      svg: 'DesempenhoPorEquipe',
      key: 'desempenho_por_equipe',
    },
  ],
  pre_natal: [
    {
      link: '/consultas-pre-natal/profissional',
      titulo: 'Consultas pré-natal',
      icone: false,
      imagem: '',
      svg: 'ConsultasPreNatal',
      key: 'consultas_pre_natal',
    },

    {
      link: '/consultas-odontologicas/profissional',
      titulo: 'Consultas odontológicas',
      icone: false,
      imagem: '',
      svg: 'ConsultasOdontologicas',
      key: 'consultas_odontologicas',
    },
    {
      link: '/exames-hiv-sifilis/profissional',
      titulo: 'Exames HIV e Sífilis',
      icone: false,
      imagem: '',
      svg: 'ExamesHivSifilis',
      key: 'hiv_sifilis',
    },
    {
      link: '/tres-indicadores-pre-natal/equipe/acs',
      titulo: 'Os 3 Indicadores Pré-natal',
      icone: false,
      imagem: '',
      svg: 'TresIndicadoresPreNatal',
      key: 'tres_indicadores_pre_natal',
    },
  ],
  doencas_cronicas: [
    {
      link: '/hemoglobina-glicada/profissional',
      titulo: 'Atendimento diabetes',
      icone: false,
      imagem: '',
      svg: 'AtendimentosDiabetes',
      key: 'atendimento_diabetes',
    },
    {
      link: '/atendimento-hipertensao/profissional',
      titulo: 'Atendimento Hipertensão',
      icone: false,
      imagem: '',
      svg: 'AtendimentoHipertensao',
      key: 'atendimento_hipertensao',
    },
    {
      link: '/hiper-dia/profissional',
      titulo: 'Atendimento HiperDia',
      icone: false,
      imagem: '',
      svg: 'HiperDia',
      key: 'atendimento_hiper_dia',
    },
  ],
  desempenho_por_equipe: [
    {
      link: '/desempenho-por-equipe/indicador',
      titulo: 'Desempenho por Indicador',
      icone: 'icofont-brand-designbump',
      key: 'desempenho_por_indicador',
    },
    {
      link: '/desempenho-por-equipe/geral',
      titulo: 'Desempenho Geral',
      icone: 'icofont-brand-designbump',
      key: 'desempenho_geral',
    },
  ],
  saude_crianca: [],
  indicadores_esb: [],
  indicadores_esb_estrategicos: [],
  indicadores_esb_ampliados: [],
  producao: [],
  vinculo_acompanhamento: [
    {
      link: '/diagnostico-situacional',
      titulo: 'Desempenho por Equipe',
      icone: false,
      imagem: '',
      svg: 'DesempenhoPorEquipe',
      key: 'diagnostico_situacional',
    },
    {
      link: '/cadastros-individuais/profissional',
      titulo: 'Cadastros cidadãos',
      icone: false,
      imagem: '',
      svg: 'CadastrosCidadaos',
      key: 'cadastros_cidadaos',
    },
    {
      link: '/acompanhamento/profissional',
      titulo: 'Acompanhamento',
      icone: false,
      imagem: '',
      svg: 'Acompanhamento',
      key: 'acompanhamento',
    },
    {
      link: '/avaliacao-atendimentos',
      titulo: 'Avaliação do atendimento',
      icone: 'icofont-heart-eyes',
      key: 'avaliacao_atendimentos',
    },
    {
      link: '/agenda-por-profissional/profissional',
      titulo: 'Agendamentos',
      icone: 'icofont-ui-calendar',
      key: 'agenda_por_profissional',
    },
  ],
  bpa_e_ras: [],
}
